module.exports = __webpack_public_path__ + "img/cancel-error.3ab844fc.png";